import React, { useEffect, useState, useRef }  from 'react';
import { Redirect } from 'react-router-dom'

export default ({ location: { search }, match }) => {
  const [redirectTo, setRedirectTo] = useState(null)
  const orderId = match.params.orderId
  const jobId = match.params.jobId
  const versionId = match.params.versionId
  const taskId = match.params.taskId

  useEffect(() => {
    if (taskId) {
      setRedirectTo(`/task/${taskId}`)
    } else {
      fetch(`/rest/v2/order/${orderId}/tasks?jobId=${jobId}&versionId=${versionId}`)
        .then((response) => response.json())
        .then(({data}) => {
          if (data.length > 1) {
            data.forEach(task => {
              window.open(`/task/${task.uid}`, '_blank')
            });
            setRedirectTo(`/dashboard`)
          } else {
            setRedirectTo(`/task/${data[0].uid}`)
          }
        })
    }
  }, [])

  if (redirectTo) {
    return (
      <Redirect to={redirectTo} />
    )
  }

  return null
}
